module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper-setting"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "bg-white min-height"
  }, [_c('home-sidebar', {
    attrs: {
      "active_item": "udb"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "bg-white min-height ml-3 pt-3"
  }, [_c('el-form', {
    ref: "form",
    staticClass: "search-form",
    attrs: {
      "model": _vm.form,
      "label-width": "90px",
      "label-position": "right"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "搜索条件"
    }
  }, [_c('el-input', {
    staticClass: "input-with-select",
    attrs: {
      "placeholder": "姓名/手机号/车牌号"
    },
    model: {
      value: (_vm.form.query),
      callback: function($$v) {
        _vm.$set(_vm.form, "query", $$v)
      },
      expression: "form.query"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "105px"
    },
    attrs: {
      "slot": "prepend",
      "placeholder": "请选择"
    },
    slot: "prepend",
    model: {
      value: (_vm.form.query_field),
      callback: function($$v) {
        _vm.$set(_vm.form, "query_field", $$v)
      },
      expression: "form.query_field"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "姓名",
      "value": "name"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "手机",
      "value": "mobileDec"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "身份证号",
      "value": "idCardDec"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "车牌",
      "value": "carInfos.carNo"
    }
  })], 1)], 1), _vm._v(" "), _c('el-button', {
    staticClass: "ml-2",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.btn_run_query
    }
  }, [_vm._v("查看结果")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.btn_cancel
    }
  }, [_vm._v("重置选项")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "出生地区"
    }
  }, [_c('el-select', {
    staticClass: "item_w",
    attrs: {
      "placeholder": "请选择省份",
      "clearable": ""
    },
    on: {
      "change": function($event) {
        return _vm.getProv($event, 'birth')
      }
    },
    model: {
      value: (_vm.form.birthProv),
      callback: function($$v) {
        _vm.$set(_vm.form, "birthProv", $$v)
      },
      expression: "form.birthProv"
    }
  }, _vm._l((_vm.provs), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('label', {
    staticClass: "item_label pad-hidden"
  }, [_vm._v("出生城市")]), _vm._v(" "), _c('el-select', {
    staticClass: "item_w pad-hidden",
    attrs: {
      "clearable": "",
      "placeholder": "请选择城市"
    },
    model: {
      value: (_vm.form.birthCity),
      callback: function($$v) {
        _vm.$set(_vm.form, "birthCity", $$v)
      },
      expression: "form.birthCity"
    }
  }, _vm._l((_vm.birthCitys), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('label', {
    staticClass: "item_label"
  }, [_vm._v("出生日期")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "item_w",
    attrs: {
      "type": "monthrange",
      "align": "left",
      "unlink-panels": "",
      "range-separator": "——",
      "start-placeholder": "开始",
      "end-placeholder": "结束",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.form.date_range),
      callback: function($$v) {
        _vm.$set(_vm.form, "date_range", $$v)
      },
      expression: "form.date_range"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动地区"
    }
  }, [_c('el-select', {
    staticClass: "item_w",
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.getProv($event, 'city')
      }
    },
    model: {
      value: (_vm.form.mobileProv),
      callback: function($$v) {
        _vm.$set(_vm.form, "mobileProv", $$v)
      },
      expression: "form.mobileProv"
    }
  }, _vm._l((_vm.provs), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('label', {
    staticClass: "item_label"
  }, [_vm._v("活动城市")]), _vm._v(" "), _c('el-select', {
    staticClass: "item_w",
    attrs: {
      "clearable": "",
      "placeholder": "请选择城市"
    },
    model: {
      value: (_vm.form.mobileCity),
      callback: function($$v) {
        _vm.$set(_vm.form, "mobileCity", $$v)
      },
      expression: "form.mobileCity"
    }
  }, _vm._l((_vm.mobileCitys), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('label', {
    staticClass: "item_label pad-hidden"
  }, [_vm._v("学历")]), _vm._v(" "), _c('el-select', {
    staticClass: "item_w pad-hidden",
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.degree),
      callback: function($$v) {
        _vm.$set(_vm.form, "degree", $$v)
      },
      expression: "form.degree"
    }
  }, _vm._l((_vm.degreeList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "标签"
    }
  }, [_c('label', {
    staticClass: "item_label pad-hidden"
  }, [_vm._v("电话")]), _vm._v(" "), _c('el-switch', {
    staticClass: "pad-hidden",
    model: {
      value: (_vm.form.mobileDec),
      callback: function($$v) {
        _vm.$set(_vm.form, "mobileDec", $$v)
      },
      expression: "form.mobileDec"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "item_label"
  }, [_vm._v("车辆")]), _vm._v(" "), _c('el-switch', {
    model: {
      value: (_vm.form.hasCar),
      callback: function($$v) {
        _vm.$set(_vm.form, "hasCar", $$v)
      },
      expression: "form.hasCar"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "item_label"
  }, [_vm._v("境外消费")]), _vm._v(" "), _c('el-switch', {
    model: {
      value: (_vm.form.abroad),
      callback: function($$v) {
        _vm.$set(_vm.form, "abroad", $$v)
      },
      expression: "form.abroad"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "item_label pad-hidden"
  }, [_vm._v("高档消费")]), _vm._v(" "), _c('el-switch', {
    staticClass: "pad-hidden",
    model: {
      value: (_vm.form.isUpper),
      callback: function($$v) {
        _vm.$set(_vm.form, "isUpper", $$v)
      },
      expression: "form.isUpper"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "item_label"
  }, [_vm._v("企业")]), _vm._v(" "), _c('el-switch', {
    model: {
      value: (_vm.form.hasPid),
      callback: function($$v) {
        _vm.$set(_vm.form, "hasPid", $$v)
      },
      expression: "form.hasPid"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "100px",
      "text-align": "right",
      "padding-right": "5px"
    }
  }, [_vm._v("评分排序")]), _vm._v(" "), _c('el-switch', {
    model: {
      value: (_vm.form.orderByCarPrice),
      callback: function($$v) {
        _vm.$set(_vm.form, "orderByCarPrice", $$v)
      },
      expression: "form.orderByCarPrice"
    }
  }), _vm._v(" "), _vm._l((_vm.form.tags), function(tag, k) {
    return _c('el-tag', {
      key: tag,
      staticClass: "ml-2",
      attrs: {
        "type": "danger",
        "closable": ""
      },
      on: {
        "close": function($event) {
          return _vm.remove_tag(tag)
        }
      }
    }, [_vm._v("\n                " + _vm._s(tag) + "\n              ")])
  })], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "评分"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "min": 0,
      "max": 100
    },
    model: {
      value: (_vm.form.minIncome),
      callback: function($$v) {
        _vm.$set(_vm.form, "minIncome", $$v)
      },
      expression: "form.minIncome"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "15px"
    }
  }, [_vm._v("到")]), _vm._v(" "), _c('el-input-number', {
    staticStyle: {
      "width": "130px"
    },
    attrs: {
      "min": 0,
      "max": 100
    },
    model: {
      value: (_vm.form.maxIncome),
      callback: function($$v) {
        _vm.$set(_vm.form, "maxIncome", $$v)
      },
      expression: "form.maxIncome"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "item_label"
  }, [_vm._v("性别")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "male"
    },
    model: {
      value: (_vm.form.gender),
      callback: function($$v) {
        _vm.$set(_vm.form, "gender", $$v)
      },
      expression: "form.gender"
    }
  }, [_vm._v("男性")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "female"
    },
    model: {
      value: (_vm.form.gender),
      callback: function($$v) {
        _vm.$set(_vm.form, "gender", $$v)
      },
      expression: "form.gender"
    }
  }, [_vm._v("女性")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": ""
    },
    model: {
      value: (_vm.form.gender),
      callback: function($$v) {
        _vm.$set(_vm.form, "gender", $$v)
      },
      expression: "form.gender"
    }
  }, [_vm._v("不限")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "p-3"
  }, [_c('div', {
    staticClass: "float-left mb-2"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, pager, next",
      "page-size": this.page.size,
      "total": this.page.total,
      "current-page": this.page.index + 1
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "float-right"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "danger"
    },
    on: {
      "click": _vm.btn_export_data
    }
  }, [_vm._v("导出数据\n              ")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    attrs: {
      "data": _vm.dataList,
      "stripe": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "property": "name",
      "label": "姓名",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "gender",
      "label": "性别",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.gender == 'male') ? _c('span', [_vm._v("男")]) : _vm._e(), _vm._v(" "), (scope.row.gender == 'female') ? _c('span', [_vm._v("女")]) : _vm._e(), _vm._v(" "), (scope.row.gender == 'unknown') ? _c('span', [_vm._v("未知")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "birthDay",
      "label": "出生日期",
      "width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "出生地区",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticStyle: {
            "float": "left"
          }
        }, [_vm._v("\n                    " + _vm._s(scope.row.birthProv) + "\n                  ")]), _vm._v(" "), (scope.row.birthCity != 'null') ? _c('div', [_vm._v("\n                    /" + _vm._s(scope.row.birthCity) + "\n                  ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "OneID",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.mobile) ? _c('div', [_vm._v("\n                    " + _vm._s(scope.row.mobile) + "\n                  ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "活动地区",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.mobileProv) ? _c('div', [_vm._v("\n                    " + _vm._s(scope.row.mobileProv) + "/" + _vm._s(scope.row.mobileCity) + "\n                  ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "school",
      "label": "毕业学校"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "degree",
      "label": "学历",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "评分",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(_vm._f("formatIncome")(scope.row.income)) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "车辆",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.carInfos), function(item) {
          return _c('div', {
            key: item.carNo
          }, [_vm._v("\n                    车牌：" + _vm._s(item.carNo) + "\n                  ")])
        })
      }
    }])
  }), _vm._v(" "), (_vm.admin) ? _c('el-table-column', {
    attrs: {
      "label": "查看",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.getInfoDetail(scope.row)
            }
          }
        }, [_vm._v("查看\n                  ")]), _vm._v(" "), (scope.row.pid) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.getCompanyList(scope.row)
            }
          }
        }, [_vm._v("企业\n                  ")]) : _vm._e()]
      }
    }], null, false, 3946078493)
  }) : _vm._e(), _vm._v(" "), (_vm.sysAdmin) ? _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.doLink(scope.row)
            }
          }
        }, [_vm._v("关联\n                  ")])]
      }
    }], null, false, 2525732079)
  }) : _vm._e()], 1)], 1)], 1)])], 1)], 1), _vm._v(" "), _c('export-data', {
    attrs: {
      "dlg_export_model": _vm.dlg_export_model,
      "form": _vm.form
    },
    on: {
      "exportClose": function($event) {
        _vm.dlg_export_model = false
      }
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "关联",
      "visible": _vm.dlg_do_link,
      "close-on-click-modal": false,
      "width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dlg_do_link = $event
      }
    }
  }, [_c('el-form', {
    ref: "pkgForm",
    attrs: {
      "model": _vm.pidForm,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticClass: "item_form",
    model: {
      value: (_vm.pidForm.name),
      callback: function($$v) {
        _vm.$set(_vm.pidForm, "name", $$v)
      },
      expression: "pidForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "UID",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticClass: "item_form",
    model: {
      value: (_vm.pidForm.uid),
      callback: function($$v) {
        _vm.$set(_vm.pidForm, "uid", $$v)
      },
      expression: "pidForm.uid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "pid",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticClass: "item_form",
    model: {
      value: (_vm.pidForm.pid),
      callback: function($$v) {
        _vm.$set(_vm.pidForm, "pid", $$v)
      },
      expression: "pidForm.pid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "hcid",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticClass: "item_form",
    model: {
      value: (_vm.pidForm.hcid),
      callback: function($$v) {
        _vm.$set(_vm.pidForm, "hcid", $$v)
      },
      expression: "pidForm.hcid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "isVip",
      "prop": "isVip"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.pidForm.isVip),
      callback: function($$v) {
        _vm.$set(_vm.pidForm, "isVip", $$v)
      },
      expression: "pidForm.isVip"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "remark",
      "prop": "remark"
    }
  }, [_c('el-input', {
    staticClass: "item_form",
    model: {
      value: (_vm.pidForm.remark),
      callback: function($$v) {
        _vm.$set(_vm.pidForm, "remark", $$v)
      },
      expression: "pidForm.remark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.btn_do_link
    }
  }, [_vm._v("立即添加")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.dlg_do_link = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dlg_slice_list,
      "width": "800px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dlg_slice_list = $event
      }
    }
  }, [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "姓名"
    }
  }, [_vm._v(_vm._s(_vm.userInfo.name))]), _vm._v(" "), (_vm.userInfo.resume) ? [_c('el-form-item', {
    attrs: {
      "label": "就读学校"
    }
  }, [_vm._v(_vm._s(_vm.userInfo.resume.schools))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "最高学历"
    }
  }, [_vm._v(_vm._s(_vm.userInfo.resume.degree))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "教育经历"
    }
  }, [_vm._v(_vm._s(_vm.userInfo.resume.edu_list))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "公司"
    }
  }, [_vm._v(_vm._s(_vm.userInfo.resume.company))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "工作经历"
    }
  }, [_vm._v(_vm._s(_vm.userInfo.resume.work_list))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "职位"
    }
  }, [_vm._v(_vm._s(_vm.userInfo.resume.position))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "薪资"
    }
  }, [_vm._v(_vm._s(_vm.userInfo.resume.salary))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "期望行业"
    }
  }, [_vm._v(_vm._s(_vm.userInfo.resume.industry))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "个人简介"
    }
  }, [_vm._v(_vm._s(_vm.userInfo.resume.desc))])] : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "OneID"
    }
  }, [_vm._v(_vm._s(_vm.userInfo.mobile))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "出生省份"
    }
  }, [_vm._v(_vm._s(_vm.userInfo.birthProv))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "出生城市"
    }
  }, [_vm._v(_vm._s(_vm.userInfo.birthCity))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动地区省份"
    }
  }, [_vm._v(_vm._s(_vm.userInfo.mobileProv))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动地区城市"
    }
  }, [_vm._v(_vm._s(_vm.userInfo.mobileCity))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "消费能力评分"
    }
  }, [_vm._v(_vm._s(_vm._f("formatIncome")(_vm.userInfo.income)))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "学历"
    }
  }, [_vm._v(_vm._s(_vm.userInfo.degree))]), _vm._v(" "), _vm._l((_vm.userInfo.carInfos), function(item) {
    return _c('el-form-item', {
      key: item.carNo
    }, [_vm._v("\n            车牌：" + _vm._s(item.carNo) + "\n      ")])
  })], 2)], 1), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "title": "相关企业列表",
      "visible": _vm.dlg_company_list,
      "size": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dlg_company_list = $event
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block search_list pl-3 pr-3"
  }, [_c('div', {
    staticClass: "main_content"
  }, [_c('el-pagination', {
    staticClass: "pb-3",
    attrs: {
      "layout": " prev, pager, next",
      "page-size": this.humPage.size,
      "total": this.humPage.total,
      "current-page": this.humPage.index + 1
    },
    on: {
      "current-change": _vm.handleHumPageChange
    }
  }), _vm._v(" "), _vm._l((_vm.humList), function(item, index) {
    return _c('div', {
      staticClass: "item"
    }, [_c('el-card', {
      staticStyle: {
        "height": "auto"
      },
      attrs: {
        "shadow": "always"
      }
    }, [_c('div', {
      staticClass: "content-box"
    }, [(item.adProv) ? _c('div', {
      staticClass: "content"
    }, [_c('div', [_vm._v("地区：" + _vm._s(item.adProv))])]) : _vm._e(), _vm._v(" "), (item.companyName) ? _c('div', {
      staticClass: "content"
    }, [_c('label', [_vm._v("公司名："), _c('span', [_vm._v(" " + _vm._s(item.companyName))])])]) : _vm._e(), _vm._v(" "), (item.scale) ? _c('div', {
      staticClass: "content"
    }, [_c('label', [_vm._v("公司规模："), _c('span', [_vm._v(" " + _vm._s(item.scale))])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('label', [_vm._v("职位："), _vm._l((item.typeJoin), function(i, v) {
      return _c('span', [_vm._v("\n                        " + _vm._s(i.trim()) + "\n                      ")])
    })], 2)]), _vm._v(" "), (item.share) ? _c('div', {
      staticClass: "content"
    }, [_c('label', [_vm._v("股份："), _c('span', [_vm._v(" " + _vm._s(item.share))])])]) : _vm._e()])])], 1)
  })], 2)])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "详细信息",
      "visible": _vm.dlg_detail,
      "width": "900px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dlg_detail = $event
      }
    }
  }, [_c('table', {}, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "rowspan": "3",
      "width": "140px"
    }
  }, [_vm._v(_vm._s(_vm.hum_item.name))]), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "3",
      "width": "70%"
    }
  }, [_vm._v(_vm._s(_vm.hum_item.introduction))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "80px"
    }
  }, [_vm._v("担任法人")]), _vm._v(" "), _c('td', [(_vm.hum_item.legalList != null) ? _c('div', [_vm._v(_vm._s(_vm.hum_item.legalList.length))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("担任股东")]), _vm._v(" "), _c('td', [(_vm.hum_item.holderList != null) ? _c('div', [_vm._v(_vm._s(_vm.hum_item.holderList.length))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("担任高管")]), _vm._v(" "), _c('td', [(_vm.hum_item.officeList != null) ? _c('div', [_vm._v(_vm._s(_vm.hum_item.officeList.length))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("合作伙伴")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, _vm._l((_vm.hum_item.partners), function(k, v) {
    return _c('span', [_vm._v(_vm._s(k.name) + " ")])
  }), 0)])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ee623b6e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/sys/Udb.vue
// module id = 293
// module chunks = 1